import { Link } from '@atlassian/amkt-common';
import React, { PureComponent } from 'react';

import SolutionsPropTypes from '../../../../constants/SolutionsPropTypes';

import styles from './SolutionAtlassianProductDiversion.less';

export default class SolutionAtlassianProductDiversion extends PureComponent {
  static propTypes = {
    atlassianProductDiversion: SolutionsPropTypes.atlassianProductDiversion.isRequired,
  };

  render() {
    return (
      <div className={styles.solutionAtlassianProductDiversion}>
        <span className={styles.introduction}>
          {/* @ts-expect-error [MC-2850] - TS2339 - Property 'atlassianProductDiversion' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
          {this.props.atlassianProductDiversion.introduction}
        </span>
        <span> Check out </span>
        {/* @ts-expect-error [MC-2850] - TS2339 - Property 'atlassianProductDiversion' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
        {this.props.atlassianProductDiversion.productLinks
          .flatMap((pl, i) => [
            <Link
              href={pl.link.href}
              key={`product-${i}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {pl.name}
            </Link>,
            <span key={`separator=${i}`}> or </span>,
          ])
          .butLast()}
        <span> to get started.</span>
      </div>
    );
  }
}
